const env = import.meta?.env?.MODE || process.env.NODE_ENV || "development";
/**
 * Log info-level messages
 * @param  {...any} args
 */
export function logInfo(...args) {
	if (env === "development") {
		console.info("ℹ️ [INFO]:", ...args);
	}
}

/**
 * Log warning-level messages
 * @param  {...any} args
 */
export function logWarning(...args) {
	if (env === "development") {
		console.warn("⚠️ [WARN]:", ...args);
	}
}

/**
 * Log error-level messages
 * @param  {...any} args
 */
export function logError(...args) {
	if (env === "development") {
		console.error("❌ [ERROR]:", ...args);
	}
}
